import React from 'react'
import ReactLoading from 'react-loading'
import { connect } from 'react-redux'

import BaseComponent from 'utils/BaseComponent'
import request from 'utils/request'

import { VEHICLES_LIST_URL } from 'constants'

import Vehicle from './Vehicle'
import { vehiclesFetched } from 'scenes/ClientDetail/actions'

import './styles.scss'



export class Vehicles extends BaseComponent {

  constructor(props) {
    super(props)

    this.state = {
      fetched: false
    }
    this._bind('_renderVehicles')
  }

  componentDidMount() {
    request(VEHICLES_LIST_URL(this.props.match.params.id))
    .then(({ vehicles }) => {
      this.props.vehiclesFetched(vehicles)
      this.setState({'fetched': true})
    })
    .catch(console.error)
  }

  _renderVehicles(vehicle, index) {
    return <Vehicle key={index} vehicle={vehicle} match={this.props.match} />
  }

  render() {
    if(!this.state.fetched) {
      return (
        <ReactLoading id="Spin" type={'spin'} color={'#444'}  />
      )
    } else {
      return (
        <div className="vehicle-list">
          {
            !!this.props.vehicles.length ? this.props.vehicles.map(this._renderVehicles) : <h1>Sin Vehículos</h1>
          }
        </div>
      )
    }
  }
}

const mapStateToProps = (state) => {
  return {
    vehicles: state.clientDetail.get('vehicles').toJS()
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    vehiclesFetched: (vehicles) => dispatch(vehiclesFetched(vehicles)),
    dispatch
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(Vehicles)



// WEBPACK FOOTER //
// ./src/scenes/ClientDetail/components/Vehicles/index.js